var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn main-bg ml-2",attrs:{"disabled":_vm.loading},on:{"click":function($event){return _vm.updateOrderStatus()}}},[_vm._v("Actualizar estado\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }